import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateSessionComponent } from './Component/masters/create-session/create-session.component';
import { CommonModule } from '@angular/common';
import { SearachCustomerComponent } from './Component/spra/searach-customer/searach-customer.component';
import { SpraRequestComponent } from './Component/spra/spra-request/spra-request.component';
import { CustomerRankUploadComponent } from './Component/spra/customer-rank-upload/customer-rank-upload.component';
import { ProductSearchComponent } from './Component/masters/product-search/product-search.component';
import { ProductPriceUploadComponent } from './Component/spra/product-price-upload/product-price-upload.component';
import { UploadCsaRateComponent } from './Component/spra/upload-csa-rate/upload-csa-rate.component';
import { SpraValidationlistComponent } from './Component/spra/spra-validationlist/spra-validationlist.component';
import { SpraRequestListComponent } from './Component/spra/spra-request-list/spra-request-list.component';
import { SpraViewDataComponent } from './Component/spra/spra-view-data/spra-view-data.component';
import { SpraServiceComponent } from './Component/spra/spra-service/spra-service.component';
import { SpraAdminsalesvalidateListComponent } from './Component/spra/spra-adminsalesvalidate-list/spra-adminsalesvalidate-list.component';
import { SpraOpenddenquiryListComponent } from './Component/spra/spra-openddenquiry-list/spra-openddenquiry-list.component';
import { SpraViewOpsComponent } from './Component/spra/spra-view-ops/spra-view-ops.component';
import { SpraRentalRequestComponent } from './Component/spra/spra-rental-request/spra-rental-request.component';
import { SpraRentalPLComponent } from './Component/masters/spra-rental-pl/spra-rental-pl.component';
import { UploadConsumableTargetComponent } from './Component/spra/upload-consumable-target/upload-consumable-target.component';
import { SpraStatusReportComponent } from './Component/spra/spra-status-report/spra-status-report.component';
import { SpraValidationComponent } from './Component/spra/spra-validation/spra-validation.component';
import { DashboardComponent } from './Component/spra/dashboard/dashboard.component';
import { RemoveSessionComponent } from './Component/masters/remove-session/remove-session.component';
import { SpraSalesadminreviewListComponent } from './Component/spra/spra-salesadminreview-list/spra-salesadminreview-list.component';
import { SpraSalesadminapprevListComponent } from './Component/spra/spra-salesadminapprev-list/spra-salesadminapprev-list.component';




const routes: Routes = [
  { path: '', redirectTo: '/search-customer', pathMatch: 'full' },
  { path: 'session', component: CreateSessionComponent },
  { path: 'rsession', component: RemoveSessionComponent },
  { path: 'rsession/:Flag', component: RemoveSessionComponent },
  { path: 'search-customer/:IsRental', component: SearachCustomerComponent },
  { path: 'search-customer', component: SearachCustomerComponent },
  //Added by rahul yadav on 1/07/2021 validation from mail
  { path: 'spra-request/:SPRAId/:RefId/:OfficeId/:CompanyId/:SaleCode/:PartnerId/:IsCeha/:UpdateTag', component: SpraRequestComponent },
  { path: 'spra-request', component: SpraRequestComponent },
  { path: 'customer-rank-upload', component: CustomerRankUploadComponent},
  { path: 'product-search', component: ProductSearchComponent},
  { path: 'product-price-upload', component: ProductPriceUploadComponent},
  { path: 'upload-csa-rate', component: UploadCsaRateComponent},
  { path: 'spra-validationlist', component: SpraValidationlistComponent},
  { path: 'spra-validationlist/:IsCeha', component: SpraValidationlistComponent}, //Added by rahul yadav on 7/06/2021
  { path: 'spra-request-list', component: SpraRequestListComponent},
  { path: 'spra-request-list/:IsCeha', component: SpraRequestListComponent}, //Added by rahul yadav on 7/06/2021  
  { path: 'spra-view-data', component: SpraViewDataComponent},
  //Added by rahul yadav on 1/07/2021 validation from mail
  { path: 'spra-service/:SPRAId/:RefId/:OfficeId/:CompanyID/:saleCode/:PartnerId/:IsCeha/:UpdateTag', component: SpraServiceComponent },
  { path: 'spra-service', component: SpraServiceComponent},
  { path: 'spra-adminsalesvalidate-list', component: SpraAdminsalesvalidateListComponent},
  { path: 'spra-adminsalesvalidate-list/:IsCeha', component: SpraAdminsalesvalidateListComponent}, //Added by rahul yadav on 7/06/2021
  { path: 'spra-salesadminreview-list', component: SpraSalesadminreviewListComponent},
  { path: 'spra-salesadminreview-list/:IsCeha', component: SpraSalesadminreviewListComponent}, //Added by rahul yadav on 06/05/2022
  { path: 'spra-salesadminapprev-list', component: SpraSalesadminapprevListComponent},
  { path: 'spra-salesadminapprev-list/:IsCeha', component: SpraSalesadminapprevListComponent}, //Added by rahul yadav on 06/05/2022
  { path: 'spra-openddenquiry-list', component: SpraOpenddenquiryListComponent},
  { path: 'spra-view-ops', component: SpraViewOpsComponent},
  { path: 'spra-view-ops/:QueryParam', component: SpraViewOpsComponent},
  //Added by rahul yadav on 1/07/2021 validation from mail
  { path: 'spra-rental-request/:SPRAId/:RefId/:OfficeId/:CompanyId/:SaleCode/:PartnerId/:IsCeha/:UpdateTag', component: SpraRentalRequestComponent },
  { path: 'spra-rental-request', component: SpraRentalRequestComponent },

  { path: 'spra-rental-pl', component: SpraRentalPLComponent },
  { path: 'spra-constarget-upload', component: UploadConsumableTargetComponent },
  { path: 'spra-status-report', component: SpraStatusReportComponent },
  { path: 'spra-status-report/:IsProfit', component: SpraStatusReportComponent },
  { path: 'spra-validation/:Id', component: SpraValidationComponent },
  { path: 'dashboard', component: DashboardComponent }
  
];



@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [CommonModule,RouterModule]
})
export class AppRoutingModule { }
